import type { HTMLProps } from "react";
import { useTranslation } from "react-i18next";

import { Typography, Arrange } from "@aviary";
import { l } from "@shared/locales/i18n";

import * as styles from "./Price.styles";

export type PriceDisplayColor = "dark" | "grey" | "green" | "text" | "darkBold" | "purple";

interface Props extends HTMLProps<HTMLSpanElement> {
  price: number;
  displayColor?: PriceDisplayColor;
  isNegative?: boolean;
  currencySymbol?: "CAN" | "US";
  blur?: boolean;
  isSecondaryWeight?: boolean;
  isPerUnit?: boolean;
  isBold?: boolean;
}

const Price = ({
  price,
  displayColor,
  isNegative,
  currencySymbol,
  blur,
  isSecondaryWeight,
  isPerUnit,
  isBold,
  ...rest
}: Props) => {
  const { t } = useTranslation();

  const minusSign = isNegative ? "-" : "";

  const spanStyles = [
    displayColor && styles.price[displayColor],
    blur && styles.blur,
    isSecondaryWeight && styles.secondaryWeight,
    isBold && styles.bold,
  ];

  const renderPrice = () => (
    <span css={spanStyles} {...rest}>{`${minusSign}${currencySymbol ? currencySymbol : ""}$${Number(
      price
    ).toFixed(2)}`}</span>
  );

  if (isPerUnit) {
    return (
      <Arrange alignment="center" spacing="xsmall" isWrapped={false} isFullWidth>
        {renderPrice()}
        <Typography css={[styles.unit, isBold && styles.bold]} type="body">
          {t(l.sharedCommon.PerUnit)}
        </Typography>
      </Arrange>
    );
  }

  return renderPrice();
};

export { Price, type Props as PriceProps };
